export const state = {
  categories: [],
  docCheckList: [],
  category: {
    cate_id: 0,
    ent_sec_code: "",
    cate_name: "",
    document_checklist: [],
    default_tenor_month: 0,
    service_amount: 0,
    unit_amount: 0,
    unit: "",
  },
};
